import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const isChunkError = this.isChunkLoadError(error);
        if (isChunkError) {
            const reloadKey = 'chunk-reload-attempted';
            const alreadyReloaded = sessionStorage.getItem(reloadKey);
            if (!alreadyReloaded) {
                sessionStorage.setItem(reloadKey, '1');
                // Force a full reload to fetch fresh chunk files
                window.location.reload();
                return;
            } else {
                sessionStorage.removeItem(reloadKey);
            }
        }

        // Fallback to default logging for other errors
        // eslint-disable-next-line no-console
        console.error(error);
    }

    private isChunkLoadError(error: any): boolean {
        if (!error) return false;
        const message = (error?.message || '').toString();
        return (
            error?.name === 'ChunkLoadError' ||
            message.includes('ChunkLoadError') ||
            message.includes('Loading chunk') ||
            message.includes('Loading CSS chunk')
        );
    }
}
